export default __webpack_public_path__ + "static/banner-60602998d5079673c45d5b2941cbe1e6.png";